import React from 'react';

/**
 * CTAButton Component
 * Primary call-to-action button that links to Zoho Bookings with pre-filled data
 * Dynamic CTA text based on quiz score
 * 
 * @param {object} leadData - Lead information to pre-fill booking form
 * @param {string} bookingUrl - Base Zoho Bookings URL
 * @param {number} overallScore - Overall quiz score (0-100) for dynamic CTA
 */
export default function CTAButton({ leadData, bookingUrl, overallScore }) {
  // Determine CTA text and supporting text based on score
  const getCTAContent = () => {
    if (overallScore <= 40) {
      // Critical issues (0-40%)
      return {
        buttonText: "LET'S STOP THE BLEEDING →",
        supportingLine1: "Book a 25-minute call to prioritize your fixes",
        supportingLine2: "Let's tackle the biggest leak first"
      };
    } else if (overallScore <= 70) {
      // Room for improvement (41-70%)
      return {
        buttonText: "LET'S FIX YOUR LEAKS →",
        supportingLine1: "Schedule a 25-minute call to recover lost revenue",
        supportingLine2: "We'll identify the highest-impact fixes"
      };
    } else {
      // Strong performance (71-100%)
      return {
        buttonText: "LET'S OPTIMIZE YOUR PIPELINE →",
        supportingLine1: "Book a 25-minute call to reach peak performance",
        supportingLine2: "Let's find those last few opportunities"
      };
    }
  };
  
  const ctaContent = getCTAContent();
  
  // Build URL with pre-fill parameters
  const buildBookingUrl = () => {
    const params = new URLSearchParams({
      name: leadData.fullName || '',
      email: leadData.email || '',
      company: leadData.companyName || '',
      website: leadData.companyWebsite || ''
    });
    
    // Zoho Bookings URL format - testing standard parameter names
    // Format: https://book.thryv.ing/#/ID?name=...&email=...
    const url = bookingUrl.includes('?') 
      ? `${bookingUrl}&${params.toString()}`
      : `${bookingUrl}?${params.toString()}`;
    
    return url;
  };
  
  const handleClick = () => {
    window.open(buildBookingUrl(), '_blank', 'noopener,noreferrer');
  };
  
  return (
    <div className="text-center">
      <button
        onClick={handleClick}
        className="btn-primary text-base sm:text-lg md:text-xl px-8 sm:px-10 md:px-12 w-full md:w-auto"
      >
        {ctaContent.buttonText}
      </button>
      <p className="text-gray-400 text-xs sm:text-sm mt-2 sm:mt-3">
        {ctaContent.supportingLine1}
      </p>
      <p className="text-gray-400 text-xs sm:text-sm">
        {ctaContent.supportingLine2}
      </p>
    </div>
  );
}

